import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import ServicesHub from "./pages/ServicesHub";
import ServiceDetail from "./pages/ServiceDetail";
import Pricing from "./pages/Pricing";
import Coupons from "./pages/Coupons";
import LocationPage from "./pages/LocationPage";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={withLayout(<Home />)} />
          <Route path="/services" element={withLayout(<ServicesHub />)} />
          <Route path="/services/:slug" element={withLayout(<ServiceDetail />)} />
          <Route path="/pricing" element={withLayout(<Pricing />)} />
          <Route path="/coupons" element={withLayout(<Coupons />)} />
          <Route path="/locations/:city" element={withLayout(<LocationPage />)} />
          <Route path="/contact" element={withLayout(<Contact />)} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={withLayout(<NotFound />)} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors offset={80} />
    </AuthProvider>
  );
}

export default App;
